import { createSlice } from '@reduxjs/toolkit'
import { fetchTasksByFilters, createTask, updateTask, fetchAssignedTaskDetails } from './actions'
import { TaskState } from './types'

const initialState: TaskState = {
  loadingFetchTasks: false,
  loadingFetchAssignedTasks: false,
  loadingAssignTask: false,
  loadingCreateTask: false,
  loadingUpdateTask: false,
  loadingUpdateAssignedTask: false,

  tasks: [],
  assignedTask: [],
  selectedTask: null,

  errorFetchTasks: '',
  errorFetchAssignedTasks: '',
  errorAssignTask: '',
  errorCreateTask: '',
  errorUpdateAssignedTask: '',
  errorUpdateTask: '',
}

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch tasks
      .addCase(fetchTasksByFilters.pending, (state) => {
        state.loadingFetchTasks = true
        state.errorFetchTasks = ''
      })
      .addCase(fetchTasksByFilters.fulfilled, (state, action) => {
        state.loadingFetchTasks = false
        state.tasks = action.payload
      })
      .addCase(fetchTasksByFilters.rejected, (state, action) => {
        state.loadingFetchTasks = false
        state.errorFetchTasks = action.error.message || 'Failed to fetch tasks'
      })

      // Add task
      .addCase(createTask.pending, (state) => {
        state.loadingCreateTask = true
        state.errorCreateTask = ''
      })
      .addCase(createTask.fulfilled, (state, action) => {
        state.loadingCreateTask = false
        state.tasks.push(action.payload)
      })
      .addCase(createTask.rejected, (state, action) => {
        state.loadingCreateTask = false
        state.errorCreateTask = action.error.message || 'Error creating task'
      })

      // Update task
      .addCase(updateTask.pending, (state) => {
        state.loadingUpdateTask = true
        state.errorUpdateTask = ''
      })
      .addCase(updateTask.fulfilled, (state, action) => {
        state.loadingUpdateTask = false
        const index = state.tasks.findIndex((task) => task.id === action.payload.id)
        if (index !== -1) {
          state.tasks[index] = action.payload
        }
      })
      .addCase(updateTask.rejected, (state, action) => {
        state.loadingUpdateTask = false
        state.errorUpdateTask = action.error.message || 'Error updating task'
      })

      // Assign task
      .addCase(fetchAssignedTaskDetails.pending, (state) => {
        state.loadingFetchAssignedTasks = true
        state.errorFetchAssignedTasks = ''
      })
      .addCase(fetchAssignedTaskDetails.fulfilled, (state, action) => {
        state.loadingFetchAssignedTasks = false
        state.assignedTask = action.payload
      })
      .addCase(fetchAssignedTaskDetails.rejected, (state, action) => {
        state.loadingFetchAssignedTasks = false
        state.errorFetchAssignedTasks = action.error.message || 'Failed to fetch assigned tasks'
      })
  },
})

export default tasksSlice.reducer
